<script lang="ts">
	import type { SbImage } from '../types';
	import Image from '../components/image.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			asset: SbImage;
			label: string;
			text_color: 'stone-5' | 'brown-2';
			text_align: 'center' | 'left';
			size: 'small' | 'regular';
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="relative">
	<Image
		class="h-full w-full rounded-[20px] object-cover"
		src={content.asset.filename}
		alt={content.asset.alt}
		width={400}
	/>
	<div
		class="absolute inset-x-0 bottom-0 text-balance text-{content.text_align ||
			'center'} font-serif {content.size === 'small'
			? 'text-[14px]/[120%]'
			: 'text-[20px]/[110%]'} tracking-[-.4px]
            text-{content.text_color || 'brown-2'}"
	>
		<p class="mx-5 mb-3">
			{content.label || ''}
		</p>
	</div>
</div>
